import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { buildTimerStylesheet } from "./ElementTimerStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementTimer = (props) => {
  let element = props.element;
  const stylesheet = buildTimerStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  if (props.builder == true) {
    useEffect(() => {
      // Builder preview is a frozen frame reflecting the timer settings —
      // no countdown runs here; the live preview handles the real countdown.
      var clock = document.querySelector(
        '#builder .cf-timer[data-id="' + element.id + '"]'
      );

      if (!clock) {
        return;
      }

      function hideTimer() {
        if (
          element.options["timer-end-action"] == "timer" ||
          element.options["timer-end-action"] == "step"
        ) {
          $(clock).css("opacity", "1");
          $(clock).find(".cf-timer-inner").show();
          $(clock).find(".cf-timer-message").show();
        } else if (element.options["timer-end-action"] == "message") {
          $(clock).css("opacity", "1");
          $(clock).find(".cf-timer-inner").hide();
          $(clock).find(".cf-timer-message").show();
        } else if (element.options["timer-end-action"] == "hide") {
          $(clock).css("opacity", "0.1");
        }
      }

      var optionValue = function (name, fallback) {
        var parsed = parseInt(element.options[name]);
        return isNaN(parsed) ? fallback : parsed;
      };

      var days = 0;
      var hours = 0;
      var minutes = 0;
      var seconds = 0;

      if (element.options["timer-type"] == "static") {
        let endDate =
          element.options["timer-date"] ||
          moment().endOf("day").format("YYYY-MM-DD h:mm:ss a");
        let t = Date.parse(endDate) - Date.parse(new Date());

        if (!(t > 0)) {
          hideTimer();
          return;
        }

        days = Math.floor(t / (1000 * 60 * 60 * 24));
        hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        minutes = Math.floor((t / 1000 / 60) % 60);
        seconds = Math.floor((t / 1000) % 60);
      } else if (element.options["timer-type"] == "daily") {
        hours = optionValue("timer-hours", 23);
        minutes = optionValue("timer-minutes", 59);
        seconds = optionValue("timer-seconds", 59);
      } else if (element.options["timer-type"] == "relative") {
        days = optionValue("timer-days", 0);
        hours = optionValue("timer-hours", 23);
        minutes = optionValue("timer-minutes", 59);
        seconds = optionValue("timer-seconds", 59);
      }

      $(clock).css("opacity", "1");
      $(clock).find(".cf-timer-inner").show();
      $(clock).find(".cf-timer-message").hide();

      var daysSpan = clock.querySelector(
        ".cf-timer-unit[data-unit-type='days'] .cf-timer-unit-number"
      );
      var hoursSpan = clock.querySelector(
        ".cf-timer-unit[data-unit-type='hours'] .cf-timer-unit-number"
      );
      var minutesSpan = clock.querySelector(
        ".cf-timer-unit[data-unit-type='minutes'] .cf-timer-unit-number"
      );
      var secondsSpan = clock.querySelector(
        ".cf-timer-unit[data-unit-type='seconds'] .cf-timer-unit-number"
      );

      if (daysSpan) {
        let daysDiv = clock.querySelector(
          ".cf-timer-unit[data-unit-type='days']"
        );
        daysSpan.innerHTML = days > 0 ? days : 0;

        if (days == 0) {
          daysDiv.classList.add("cf-timer-hidden");
        } else {
          daysDiv.classList.remove("cf-timer-hidden");
        }
      }
      if (hoursSpan) {
        let hoursDiv = clock.querySelector(
          ".cf-timer-unit[data-unit-type='hours']"
        );
        hoursSpan.innerHTML = hours > 0 ? hours : 0;

        if (days == 0 && hours == 0) {
          hoursDiv.classList.add("cf-timer-hidden");
        } else {
          hoursDiv.classList.remove("cf-timer-hidden");
        }
      }
      if (minutesSpan) {
        let minutesDiv = clock.querySelector(
          ".cf-timer-unit[data-unit-type='minutes']"
        );
        minutesSpan.innerHTML = minutes > 0 ? minutes : 0;

        if (days == 0 && hours == 0 && minutes == 0) {
          minutesDiv.classList.add("cf-timer-hidden");
        } else {
          minutesDiv.classList.remove("cf-timer-hidden");
        }
      }
      if (secondsSpan) {
        secondsSpan.innerHTML = seconds > 0 ? seconds : 0;
      }
    }, [element.lastUpdated]);
  }

  return (
    <React.Fragment>
      <div
        id={"element" + element.id + "-content"}
        className="element-content cf-timer"
        data-id={element.id}
        data-timer-type={element.options["timer-format"]}
      >
        {element.options["timer-format"] != "inline" && (
          <div className="cf-timer-inner cf-timer-card">
            {[undefined, "d/h/m/s", "d/h/m", "d/h", "d"].includes(
              element.options["timer-units"]
            ) && (
              <div
                className="cf-timer-unit cf-timer-unit-block"
                data-unit-type="days"
              >
                <div
                  className="cf-timer-unit-number"
                  data-font={element.options["timer-number-font"]}
                >
                  0
                </div>
                <div
                  className="cf-timer-unit-text"
                  data-font={element.options["timer-unit-font"]}
                >
                  {element.options["timer-days-translation"]
                    ? element.options["timer-days-translation"]
                    : "Days"}
                </div>
              </div>
            )}
            {[undefined, "d/h/m/s", "d/h/m", "d/h"].includes(
              element.options["timer-units"]
            ) && (
              <div
                className="cf-timer-unit cf-timer-unit-block"
                data-unit-type="hours"
              >
                <div className="cf-timer-unit-number">0</div>
                <div className="cf-timer-unit-text">
                  {element.options["timer-hours-translation"]
                    ? element.options["timer-hours-translation"]
                    : "Hours"}
                </div>
              </div>
            )}
            {[undefined, "d/h/m/s", "d/h/m"].includes(
              element.options["timer-units"]
            ) && (
              <div
                className="cf-timer-unit cf-timer-unit-block"
                data-unit-type="minutes"
              >
                <div className="cf-timer-unit-number">0</div>
                <div className="cf-timer-unit-text">
                  {element.options["timer-minutes-translation"]
                    ? element.options["timer-minutes-translation"]
                    : "Minutes"}
                </div>
              </div>
            )}
            {[undefined, "d/h/m/s"].includes(
              element.options["timer-units"]
            ) && (
              <div
                className="cf-timer-unit cf-timer-unit-block"
                data-unit-type="seconds"
              >
                <div className="cf-timer-unit-number">0</div>
                <div className="cf-timer-unit-text">
                  {element.options["timer-seconds-translation"]
                    ? element.options["timer-seconds-translation"]
                    : "Seconds"}
                </div>
              </div>
            )}
          </div>
        )}
        {element.options["timer-format"] == "inline" && (
          <div
            className="cf-timer-inner cf-timer-inline"
            data-font={element.options["timer-number-font"]}
          >
            <div className="cf-timer-inner cf-timer-inline">
              {[undefined, "d/h/m/s", "d/h/m", "d/h", "d"].includes(
                element.options["timer-units"]
              ) && (
                <div
                  className="cf-timer-unit cf-timer-unit-inline"
                  data-unit-type="days"
                >
                  <span className="cf-timer-unit-number">0</span>{" "}
                  <span className="cf-timer-unit-text">
                    {element.options["timer-days-translation"]
                      ? element.options["timer-days-translation"]
                      : "Days"}
                  </span>
                </div>
              )}
              {[undefined, "d/h/m/s", "d/h/m", "d/h"].includes(
                element.options["timer-units"]
              ) && (
                <div
                  className="cf-timer-unit cf-timer-unit-inline"
                  data-unit-type="hours"
                >
                  {" "}
                  <span className="cf-timer-unit-number">0</span>{" "}
                  <span className="cf-timer-unit-text">
                    {element.options["timer-hours-translation"]
                      ? element.options["timer-hours-translation"]
                      : "hours"}
                  </span>
                </div>
              )}
              {[undefined, "d/h/m/s", "d/h/m"].includes(
                element.options["timer-units"]
              ) && (
                <div
                  className="cf-timer-unit cf-timer-unit-inline"
                  data-unit-type="minutes"
                >
                  {" "}
                  <span className="cf-timer-unit-number">0</span>{" "}
                  <span className="cf-timer-unit-text">
                    {element.options["timer-minutes-translation"]
                      ? element.options["timer-minutes-translation"]
                      : "minutes"}
                  </span>
                </div>
              )}
              {[undefined, "d/h/m/s"].includes(
                element.options["timer-units"]
              ) && (
                <div
                  className="cf-timer-unit cf-timer-unit-inline"
                  data-unit-type="seconds"
                >
                  {" "}
                  <span className="cf-timer-unit-number">0</span>{" "}
                  <span className="cf-timer-unit-text">
                    {element.options["timer-seconds-translation"]
                      ? element.options["timer-seconds-translation"]
                      : "seconds"}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        {element.options["timer-end-action"] == "message" && (
          <div
            className="cf-timer-message cf-merge-tag-allowed"
            data-font={element.options["timer-message-font"]}
            dangerouslySetInnerHTML={{
              __html: element.html,
            }}
          ></div>
        )}
      </div>
      <BuilderStyleTag
        builder={props.builder}
        styleKey={`cta:${props.cta.id}:element:${element.id}:timer`}
        stylesheet={stylesheet}
      />
    </React.Fragment>
  );
};

export default ElementTimer;
